import { CONFIG } from "../../config";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";
import { KlearlyAPKConfig } from "../../interfaces/klearlyApkConfig.interface";

// Public endpoint: GET /apk/latest
export async function fetchLatestApkConfig(): Promise<KlearlyAPKConfig> {
  const axios = await getTokenizedAxios();
  const path = "/apk/latest";
  return axios
    .get(CONFIG.SERVER.BASE_URL + path)
    .then((res) => res?.data?.apkConfig ?? res?.data);
}

// Authenticated endpoint: PUT /apk/config
export async function updateApkConfig(
  partialConfig: Partial<KlearlyAPKConfig>
): Promise<KlearlyAPKConfig> {
  const axios = await getTokenizedAxios();
  const path = "/apk/config";
  return axios
    .put(CONFIG.SERVER.BASE_URL + path, { config: partialConfig })
    .then((res) => res?.data?.apkConfig ?? res?.data);
}
